import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ name: "MHorizontalQuestionnaire", namespaced: true })
export default class MHorizontalQuestionnaire extends VuexModule {
  isOpen = false;

  @Mutation
  open() {
    this.isOpen = true;
  }

  @Mutation
  close() {
    this.isOpen = false;
  }

  taskId = 0;

  @Mutation
  setTaskId(payload: number) {
    this.taskId = payload;
  }
}
